import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type CompanyState = {
  name: string;
  legal_name: string;
  tax_id: string;
  email: string;
  phone: string;
  website: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  currency_code: string;
  timezone?: string;
  logo_url?: string | null;
  /** Data URL (base64) cache for the logo image to avoid repeated fetches */
  logo_data_url?: string | null;
};

export const initialCompanyState: CompanyState = {
  name: '',
  legal_name: '',
  tax_id: '',
  email: '',
  phone: '',
  website: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  postal_code: '',
  country: '',
  currency_code: '',
  timezone: '',
  logo_url: null,
  logo_data_url: null,
};

const companySlice = createSlice({
  name: 'companyProfile',
  initialState: initialCompanyState,
  reducers: {
    setCompany(state, action: PayloadAction<Partial<CompanyState>>) {
      return { ...state, ...action.payload };
    },
    resetCompany: () => initialCompanyState,
  },
});

export const { setCompany, resetCompany } = companySlice.actions;
export default companySlice.reducer;
